/**
 * Known gaps and adoption failures, surfaced in the catalog itself.
 *
 * A design system's honest state includes what it does NOT cover. Listing gaps
 * beside the covered components is what stops the next builder from concluding
 * "there's nothing for this" and inventing a tenth version — they can see it is
 * a known gap with a rank, rather than an open field.
 *
 * Counts are measured, not estimated; the commands are in
 * docs/3-system/02-living-documents/DESIGN_SYSTEM_REGISTER.md.
 */
import type { CatalogEntry } from './componentCatalog.types';

export const GAP_CATALOG: CatalogEntry[] = [
  {
    id: 'gap-stepper',
    name: 'Stepper',
    tier: 'organism',
    status: 'gap',
    importPath: '— not built —',
    description: 'Progress through an ordered, multi-step flow.',
    note:
      'Gap. 286 step-tracking implementations across 37 files (wizards, session setup, onboarding). Deliberately not built yet: the flows differ enough that a shared component needs a real survey of what they have in common first, and guessing that would produce a component nobody fits.',
  },
  {
    id: 'gap-menu',
    name: 'Menu / Dropdown',
    tier: 'organism',
    status: 'gap',
    importPath: '— not built —',
    description: 'A button that opens a list of actions, with keyboard navigation.',
    note:
      'Gap. Only 5 files use aria-haspopup, but every menu in the app is hand-built and none share keyboard behaviour. Low count, high correctness cost — a menu is one of the hardest things to get right by hand.',
  },
  {
    id: 'gap-pagination',
    name: 'Pagination',
    tier: 'molecule',
    status: 'gap',
    importPath: '— not built —',
    description: 'Page-through controls for a long result set.',
    note: 'Gap, 3 files. Genuinely rare — build it when a fourth appears, not before.',
  },
  {
    id: 'gap-chart',
    name: 'Chart primitives',
    tier: 'organism',
    status: 'gap',
    importPath: '— not built —',
    description: 'Sparkline, bar, and line primitives on the token palette.',
    note:
      'Gap. The design-language section has a data-visualization page, but there is no charting component anywhere in the tree — so the page documents a standard nothing implements. The investor deck sets the visual register: hairline axes, a single accent, no gridlines.',
  },
];
